import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { InputModule, IconModule, LoaderModule } from '@liberty-financial/ng-components';

import { SearchComponent } from './search.component';

@NgModule({
  declarations: [
    SearchComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InputModule,
    IconModule,
    LoaderModule
  ],
  exports: [
    SearchComponent
  ]
})
export class SearchModule { }
